/* eslint-disable no-nested-ternary */
import React from 'react'
import {FiFile, FiPaperclip} from 'react-icons/fi'
import {VmoLabel, VmoListItem, VmoCheckbox, VmoTooltip, VmoIcon} from 'vmo-library'
import UserImage from 'components/common/UserImage'
import {GetFormattedDate, get, getBadgeColorPriority, startCase, wrapText} from 'utils/helper'

const getLabelColor = status => {
  if (status === 'New') return 'blue'
  if (status === 'Open') return 'red'
  if (status === 'On Hold') return 'yellow'
  if (status === 'Closed') return 'green'
  return 'white'
}

const getName = data => {
  return (
    (get(['firstName'], data) + get(['lastName'], data)
      ? `${get(['firstName'], data, '')}
      ${get(['lastName'], data, '')}`
      : false) ||
    get(['name'], data) ||
    get(['email'], data) ||
    get(['username'], data, '')
  )
}

const EmailListItem = props => {
  const {
    id,
    bulkSelect,
    convPriority,
    emailListItemData,
    iconName,
    checkedConversations,
    currentlySelectedItem,
    isRead,
    updatedAt,
    subTitle,
    mailText,
    mailDraftStatus,
  } = props

  const isItemChecked = () => {
    return checkedConversations.indexOf(Number(id)) !== -1
  }
  // oncheck of individual checkbox
  function onCheck(e) {
    e.stopPropagation()

    if (isItemChecked()) {
      props.updateCheckedConversation('remove', id)
    } else {
      props.updateCheckedConversation('add', id)
    }
  }

  const itemBgColor = currentlySelectedItem === id ? 'active' : !isRead ? 'unread_mail_bg' : 'read_mail_bg'
  const fontClass = isRead ? 'normal-font' : 'bold-font'

  function convClicked(e) {
    if (checkedConversations.length === 0 && currentlySelectedItem !== id) {
      props.onClick(e)
    }
    if (checkedConversations.length > 0) {
      onCheck(e)
    }
  }

  return (
    <VmoListItem className={itemBgColor} onClick={convClicked}>
      <div className="emailListHeader">
        <h5 className={fontClass}>
          {bulkSelect && <VmoCheckbox checked={isItemChecked()} id={id} onClick={onCheck} />}
          {wrapText(getName(emailListItemData.contact), 35)}

          {get(['totalMessages'], emailListItemData, 0) > 1 && (
            <span className="ml-1">({get(['totalMessages'], emailListItemData, 0)})</span>
          )}

          {get(['attachment'], emailListItemData) && <FiPaperclip className="attach" />}
        </h5>
        <span>
          {emailListItemData && !get(['isRead'], emailListItemData, false) && <div className="unreadDot" />}
          {startCase(get(['status', 'status'], emailListItemData)) && (
            <VmoLabel
              size="tiny"
              color={getLabelColor(startCase(emailListItemData.status.status))}
              className="vmo-label mr-2"
            >
              {startCase(emailListItemData.status.status)}
            </VmoLabel>
          )}
          {GetFormattedDate(updatedAt)}
        </span>
      </div>
      <div className="emailListBody">
        <p className={fontClass}>{subTitle}</p>
        {convPriority && convPriority !== 'default' && (
          <VmoLabel basic size="tiny" color={getBadgeColorPriority(convPriority)}>
            {startCase(convPriority)}
          </VmoLabel>
        )}
      </div>
      <div className="emailListFooter">
        <p>
          {mailText}
          {mailDraftStatus && (
            <span className="draftText">
              <FiFile /> Draft
            </span>
          )}
        </p>
        <div className="d-flex">
          {get(['assignee'], emailListItemData) && (
            <VmoTooltip
              position="right center"
              content={getName(get(['assignee'], emailListItemData))}
              trigger={
                <div className="mr-3">
                  <UserImage profile={emailListItemData.assignee} />
                </div>
              }
            />
          )}
          <VmoTooltip
            position="left center"
            content={startCase(get(['mailbox', 'name'], emailListItemData, '-'))}
            trigger={
              <div>
                <VmoIcon name={iconName} className={iconName === 'call' ? 'InboxcallIcon' : ''} />
              </div>
            }
          />
        </div>
      </div>
      {(emailListItemData?.labels || []).length > 0 && (
        <div className="emailListTag pt-3">
          {(emailListItemData?.labels || [])
            .filter((item, index) => index < 3)
            .map(tag => (
              <VmoLabel
                key={tag.id}
                style={{cursor: 'text'}}
                basic
                color={tag.color}
                // color="white"
                as="a"
                className="vmo-tag ml-0"
              >
                {tag.label}
              </VmoLabel>
            ))}
        </div>
      )}
    </VmoListItem>
  )
}

export default EmailListItem
